import Component from 'component';

class InspirationBoard extends Component {
  constructor(el) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      $window: $(window),
      $inspirations: this.$el.find('.inspiration-board__inspiration')
    };
  }

  addListeners() {
    this.dom.$window.on('scroll resize load', ::this.findMiddleElement);
  }

  findMiddleElement() {
    const deviceMiddle = this.dom.$window.height() / 2;

    this.dom.$inspirations.each((index, element) => {
      const rect = element.getBoundingClientRect();

      if (rect.y <= deviceMiddle && rect.y + rect.height >= deviceMiddle) {
        $(element).addClass('in-view');
      } else {
        $(element).removeClass('in-view');
      }
    });
  }
}

export default InspirationBoard;



// WEBPACK FOOTER //
// ./src/tc/js/components/InspirationBoard.js